import { useState } from 'react';
import HeroBanner from './components/HeroBanner';
import ResultsGrid from './components/ResultsGrid';
import FeaturedReviews from './components/FeaturedReviews';
import Header from './components/Header';

function App() {
  const [searchQuery, setSearchQuery] = useState('');
  const [results, setResults] = useState([]);
  const [loading, setLoading] = useState(false);
  const [hasSearched, setHasSearched] = useState(false);

  const handleSearch = async (query) => {
    if (!query.trim()) return;

    setSearchQuery(query);
    setLoading(true);
    setHasSearched(true);

    try {
      const response = await fetch(
        import.meta.env.VITE_API_URL
          ? `${import.meta.env.VITE_API_URL}/search`
          : '/api/search',
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({ query, limit: 20, offset: 0 }),
        }
      );

      if (!response.ok) {
        throw new Error('Search failed');
      }

      const data = await response.json();
      setResults(data.results || []);
    } catch (error) {
      console.error('Search error:', error);
      setResults([]);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-slate-50">
      <Header />

      <main>
        {/* Hero Banner with Integrated Search */}
        {!hasSearched && <HeroBanner onSearch={handleSearch} />}

        {/* Featured Reviews (on landing page, before any search) */}
        {!hasSearched && <FeaturedReviews />}

        {/* Search Results Section */}
        {hasSearched && (
          <div className="container mx-auto px-4">
            {/* Loading State */}
            {loading && (
              <div className="flex justify-center items-center py-16">
                <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-sky-600"></div>
              </div>
            )}

            {/* Results Grid */}
            {!loading && (
              <div className="my-12">
                <div className="mb-6">
                  <h2 className="text-2xl font-bold text-slate-900">
                    Results for "{searchQuery}"
                  </h2>
                  <p className="text-slate-600 mt-1">
                    {results.length} results found
                  </p>
                </div>
                <ResultsGrid results={results} />
              </div>
            )}

            {/* Empty State */}
            {!loading && results.length === 0 && (
              <div className="text-center py-16">
                <p className="text-lg text-slate-600">
                  No results found for "{searchQuery}"
                </p>
                <p className="text-slate-500 mt-2">
                  Try searching for a different product
                </p>
              </div>
            )}
          </div>
        )}
      </main>

      {/* Footer */}
      <footer className="border-t border-slate-200 bg-white mt-16">
        <div className="container mx-auto px-4 py-8 text-center text-slate-600 text-sm">
          <p>
            Consensus aggregates reviews from multiple sources for comprehensive product insights.
          </p>
          <p className="mt-2">© 2026 Consensus. Not affiliated with reviewed products.</p>
        </div>
      </footer>
    </div>
  );
}

export default App;
